import { TrackedOverlayContext } from '@objectiv/tracker-react';
import { createPortal } from 'react-dom';
import clsx from 'clsx';
import Close from './assets/close.svg';

import * as styles from './Modal.module.css';

type ModalProps = {
  open?: boolean;
  children?: React.ReactNode;
  onClose?: () => void;
  className?: string;
  trackingId?: string;
};

export const Modal: React.FC<ModalProps> = ({ open, children, onClose, className, trackingId }) => {
  if (!open) return null;

  return createPortal(
    <TrackedOverlayContext
      objectiv={{ Component: 'div', id: trackingId, isVisible: open }}
      data-modal='backdrop'
      className={styles.backdrop}
      onClick={(event: PointerEvent) => {
        if ((event.target as HTMLDivElement).dataset.modal === 'backdrop') {
          onClose?.();
        }
      }}
    >
      <div className={clsx(styles.modal, className)}>
        <Close className={styles.close} onClick={onClose} />
        {children}
      </div>
    </TrackedOverlayContext>,
    document.getElementById('modal')!,
  );
};
